<template>
  <div class="all_form_block" data-name="social">
    <div class="block">
      <div class="name_tools" id="cv-social">{{ $store.getters.cv_t('social') }}</div>
      <div class="all_form">
        <br>
        <switch-button v-model="$store.state.cv.hasSocial"></switch-button>
        <template v-if="$store.state.cv.hasSocial">
          <div class="inp_info">
            <div class="div_relative active">
              <input
                name="social"
                v-validate="'required'"
                type="text"
                v-model="$store.state.cv.tmpSocial.url"
                @input="checkSocial"
              >
            </div>
          </div>
          <div class="add_more">
            <input class="button_style" id="social_add" type="button" value @click="add()">
          </div>
        </template>
      </div>
    </div>
    <div class="edit_block_form inp_info" v-if="$store.state.cv.hasSocial">
      <div
        class="div_relative"
        v-for="(item, index ) in this.$store.state.cv.cvSocials"
        :key="index"
      >
        <div class="close" @click="$store.state.cv.cvSocials.splice(index, 1)"></div>
        <div class="edit" @click="edit(index)"></div>
        <div class="icon_inp clearfix">
          <div class="icon">
            <img :src="item.icon || '/images/cv_1_link_icon.png'" width="30" height="30">
          </div>
          <div class="div_relative active">
            <input type="text" :value="item.url" disabled>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SwitchButton from "../../../../helpers/switch-button";

export default {
  components: {
    SwitchButton
  },
  watch: {
    // '$store.state.cv.cvSocials'(to, from){
    //   this.$parent.socialIcons.forEach(icon => {
    //     to.forEach(soc => {
    //       if(soc.url.indexOf(icon["title"] !== -1)){
    //         soc.icon = icon.icon
    //       }
    //     })
    //   });
    // }
  },
  methods: {
    checkSocial(e) {
      const icons = this.$parent.socialIcons;
      for (let icon in icons) {
        if (e.target.value.indexOf(icons[icon]["title"]) !== -1) {
          this.$store.state.cv.tmpSocial.icon = icons[icon]["icon"];
          this.$store.state.cv.tmpSocial.class_name = icons[icon]["class_name"];
          break;
        } else {
          this.$store.state.cv.tmpSocial.icon = null;
          this.$store.state.cv.tmpSocial.class_name = '';
        }
      }
    },
    add() {
      this.$validator.validate().then(res => {
        if (res) {
          if(Number.isInteger(this.$store.state.cv.cvSocialsEditIndex)){
            this.$store.state.cv.cvSocials[
                this.$store.state.cv.cvSocialsEditIndex
                ] = this.$store.state.cv.tmpSocial;
          }else{
            this.$store.state.cv.cvSocials.unshift({
              ...this.$store.state.cv.tmpSocial
            });
          }

          this.$store.state.cv.tmpSocial = { icon: null, url: "", class_name: "" };
        }
      });
    },
    edit(index) {
      this.$store.state.cv.tmpSocial = this.$store.state.cv.cvSocials[index];
      // this.$store.state.cv.cvSocials.splice(index, 1);
      this.$store.commit('cvSocialsEditIndex', index);
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/cv/tools-components/Social.vue